module.exports = __webpack_public_path__ + "static/media/5.32c32a8e.png";